import { arrayOf, func, number, shape, string } from 'prop-types'
import React from 'react'
import HallUses from './HallUses'
import Location from './Location'
import StatsItem from './StatsItem'
import YearBuiltOrRenovated from './YearBuiltOrRenovated'

const ListItem = props => (
  <div className="list-item">
    <a href={props.url} onClick={props.onClick}>
      <div className="left">
        <div className="image">
          {props.image !== null &&
            <img alt="" src={props.image} />
          }
        </div>
      </div>
      <div className="middle">
        <div className="site-building">{props.siteBuilding}</div>
        <div className="name">{props.name}</div>
      </div>
      <div className="right">
        <div>
          <Location
            city={props.city}
            country={props.country}
            stateProvinceAbbreviation={props.stateProvinceAbbreviation}
          />
        </div>
        <div>
          <YearBuiltOrRenovated
            yearBuilt={props.yearBuilt}
            yearRenovated={props.yearRenovated}
          />
        </div>
        <div>
          <StatsItem
            heading="Seat count"
            slug="seat-count"
            value={props.seatCount}
          />
        </div>
        <div>
          <HallUses hallUses={props.hallUses} />
        </div>
      </div>
    </a>
  </div>
)
ListItem.defaultProps = {
  city: null,
  country: null,
  hallUses: [],
  image: null,
  seatCount: null,
  stateProvinceAbbreviation: null,
  yearBuilt: null,
  yearRenovated: [],
}
ListItem.propTypes = {
  city: string,
  country: string,
  hallUses: arrayOf(string),
  image: string,
  name: string.isRequired,
  onClick: func.isRequired,
  seatCount: number,
  siteBuilding: string.isRequired,
  stateProvinceAbbreviation: string,
  url: string.isRequired,
  yearBuilt: number,
  yearRenovated: arrayOf(number),
}

export default ListItem
